export default __webpack_public_path__ + "static/media/16-100.c8038bc6.jpg";